const Form007SC = {
    stepName: {
        importantNotes: "重要告示",
        announcements: "填写电子表格",
        confirmation: "确认",
    },
    label: {
        statement: {
            title: {
                title1: "个人资料收集声明",
                title2: "教育局会利用本表格所载的个人资料，作以下其中一种或多种用途︰",
            },
            note: {
                a: "计算及处理发放校本津贴；",
                b: "进行核数工作； ",
                c: "进行研究及统计资料，以便规划教育服务；",
                d: "执行《教育条例》、《教育规例》及附属《补助/津贴学校公积金规则》(第279章)。",
                note1: "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
                note2: "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
                note3: "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
                note4: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向教育局提出。",
            },
        },
        title: {
            header: "校本课后学习及支援计划{{endDateOfCurrentSchoolYear}}学年",
            title1: "摘要 ",
            title2: "详情",
            title3: "计划目的",
            title4: "灵活安排",
            title5: "鼓励性拨款特別安排",
            title6: "申请「校本津贴」  ",
            title7: " 「区本计划」",
            title8: " 查询 ",
            title9: "备忘事项︰",
            note: "注",
        },
        note: {
            note1: "本电子表格让学校申请 {{endDateOfCurrentSchoolYear}} 学年「校本课后学习及支援计划」(「下称「课后计划」) 下的「校本津贴」，以补充学校为支援清贫学生而举办的课后活动。 ",
            note2: "为支援清贫学生参与课后活动，以帮助他们全人发展及个人成长，教育局由 2005/06 学年开始实施「课后计划」，现时向公营学校 (包括特殊学校)和直接资助计划学校，以及非政府机构分别提供「校本津贴」及「区本计划」拨款，为清贫学生分别筹办校本及区本的课后活动。 「课后计划」的对象学生是那些领取综合社会保障援助（综援）及学生资助计划全额津贴的小一至中六学生。详情见本局网页 ( ",
            note2lianjie: "http://www.edb.gov.hk/en/salsp",
            dot: " )。",
            note3: "3. 为了让更多不在综援／学生资助计划全额津贴之列但亦属清贫而需学校多加照顾的学生也能受惠，教育局为参与学校提供酌情名额；并由 2014/15 学年开始，把有关名额由 10%增加至 25%，让更多学生受惠。此外，学校可运用「校本津贴」购买物资／器材 (例如运动用品／具教育意义的益智玩具／棋类／书籍／小食／饮料等)，以及资助个别学生参与课后活动的交通费。惟上述开支须切合活动需要，并只适用于参与课后活动的清贫学生。为避免上述开支与获提供的「校本津贴」不成比例，上述开支的总额不应超逾学校获提供的「校本津贴」总额的 5%。 ",
            note4: `4. 现行安排下，本局会审视参与学校已提交的最近一年周年账目，视乎学校运用「校本津贴」的情况，为参与学校提供鼓励性拨款。因应2019冠状病毒病疫情，学校为支援清贫学生举办的课后活动或会在停课／半天面授课堂期间受到影响，以致2019/20学年的周年账目未必能实际反映学校使用「校本津贴」的正常情况。因此，本局现作出特别安排，以参与学校已提交的最近三年周年账目`,
            note4a: "，审视学校运用「校本津贴」的情况，以决定参与学校在2021/22学年是否可获得「校本津贴」鼓励性拨款，以支援清贫学生的全人发展。",
            note4b: "5. 具体来说，局方会根据学校在2019/20学年「校本津贴」使用率",
            note4c: "或2018/19学年及2017/18学年的平均使用率计算，以较高者为准，如能达80%或以上的参与学校，每名合资格学生的每年「校本津贴」额会由原来的400元上调至600元，而有关学校亦会获得以600元计算因酌情名额而提供的额外25%的「校本津贴」。至于其他参与学校，每名合资格学生的每年「校本津贴」额则以400元计算。",
            note5: "学校须于指定截止日期前提交电子表格予延伸支援计划组办理。",
            // note5a: "2021年6月25日",
            // note5b: "或之前交回本局延伸支援计划组办理。我们一贯会在 2020 年 7 月下旬拨款予参加学校，同时知会学校计算拨款的详情。 ",
            note6: "7. 若学校与非政府机构协作推行 2021/22 学年「区本计划」 (如适用)，亦请学校协助监察有关机构执行计划的进度及表现，并与其保持紧密沟通，确保所提供的服务切合清贫学生的不同需要。由 2017/18 学年起，本局已调整「区本计划」有关财务的安排，当中包括发放予非政府机构三期拨款的比例及机构递交周年帐目的日期等，以利「区本计划」能更有效地推行。详情请参阅载于本局网页的「区本计划指引」( ",
            note6lianjie: "http://www.edb.gov.hk/salsp ",
            note7: " → 区本计划 ).",
            note8: "如有查询，请与延伸支援计划组联络 (电话： 2892 6653)。",
            note9: "教育局常任秘书长",
            note10: "陈慕颜代行",
            note11: " ",
            note12: "二零二一年六月十一日 ",
            note13: "1. 资助、按位津贴学校及直接资助计划学校的周年账目以学年为基础；现时学校呈交最近三年的周年账目为2019/20、2018/19及2017/18学年；官立学校则以财政年度为基础，即2020-21、2019-20 及2018-19财政年度的账目。",
            note14: "2. 使用率按有关年度「校本津贴」实际总开支及获提供「校本津贴」的拨款总额计算。 ",
            note15: "_______________________________",
            note16: "1.「校本课后学习及支援计划」的拨款属补充性质。为照顾清贫学生的不同需要，教育局鼓励学校灵活调配资源，及／或参加现时政府／慈善机构设有的多个资助计划。 ",
            note17: "2. 学校应让相关持份者包括家长了解学校如何在课后活动方面支援清贫学生，进一步提高透明度。此外，学校须于学校周年计划内具体列明校本计划的安排，并须于 2020 年 10 月底前把学校周年计划上载学校网页。学校须每年检讨校本计划，并在学校报告反映检讨结果。学校须于 2020 年 11 月底前把报告上载学校网页，否则，2020/21 年度发放的「校本津贴」会被撤回。 ",
            note18: "3. 学校可保留「校本津贴」的剩余款项，但以不超逾当年度「校本津贴」的拨款总额为限，超出的款项须退还教育局。至于官立学校方面，有关安排则以财政年度为基础。 ",
            note19: "就本学年的「校本课后学习及支援计划 - 校本津贴」申请，本校已知悉有关计划的安排。 ",
        },
        termsConditions: "本人已阅读、明白及同意上述条款及细则。",
        iamSignCheck: "本人理解此电子表格必须由校监使用「智方便+」签署。",
        header: "(请在适当方格内加上“√”号) ：      ",
        reason: "原因：",
        headerOption: {
            header1:
                "本校遵照「校本课后学习及支援计划」的条件，申领「校本津贴」，为合资格学生筹办校本课后学习活动。 ",
            header2: "本校无意申领「校本津贴」。 ",
        },
        namOofSupervisor: "校监姓名",
        nameOfSchool: "学校名称",
        schoolCode: "学校编号",
        schoolLevel: "学校级别",
        financeType: "财政类别",
        schoolTelNo: "学校电话号码",
        contactPerson: "联络人姓名",
        errorMsg: {
            E0001: "如果你选择第二个选项，请写明原因",
            E0002: "请输入一个有效的原因",
            notTheSame: "选项1和选项2不能同时选择",
            schoolCodeMin: "请输入6位数的学校代码",
        },
        memorandum: {
            title: "备忘事项：",
            noteOptions: {
                text0: "「校本课后学习及支援计划」属补充性质，教育局鼓励学校灵活调配「校本津贴」及其他各项相关津贴，加强协同效应，为清贫学生举办多元化的课后学习活动。",

                text1: "学校应让相关持份者包括家长了解学校如何在课后学习活动方面支援清贫学生，进一步提高透明度。此外，学校须将其运用「校本津贴」支援清贫学生的校本计划及其他配套措施（如有）具体列明在活动计划表内，并须于{{schoolyearBefore}}年10月底前把活动计划表连同学校周年计划上载至学校网页。学校须每年检讨运用「校本津贴」的情况，并在活动报告表反映检讨结果，有关活动报告表须连同学校报告于{{schoolyearAfter}}年11月底前上载至学校网页。若学校未能符合上述要求，{{schoolyear}}年度发放的「校本津贴」或会被撤回。",

                text2: "学校须每年填写「校本津贴」问卷，并交回教育局，让教育局了解学校运用「校本津贴」的情况。",

                text3: "资助、按位津贴及直接资助计划学校可保留「校本津贴」的剩馀款项，但以不超逾相关学年「校本津贴」的拨款总额为限，超出的款项须退还教育局。至于官立学校方面，学校可按校情预先申请保留每一年度的「校本津贴」，剩馀的「校本津贴」须于该财政年度完结时退还教育局。",
            },
        },
    },
    dialog: {
        message:
            "提交表格后，系统会发出电邮通知指定审批人(一般为校监)进行审批。申请人不能再修改已提交的表格。",
    },
};
export default Form007SC;
